const performanceDashboard = {
  title: 'לוח ביצועים',
  subTitle: 'סקירה של מדדים תפעוליים מרכזיים',
  supplierSelector: {
    label: 'בחר ספק:',
  },
  acceptDeclineTripsPie: {
    title: 'נסיעות מאושרות / נדחות',
    pies: {
      accept: 'אישור',
      decline: 'דחייה',
    },
  },
  assignmentTypePie: {
    title: 'סוג השמה',
    pies: {
      manual: 'ידני',
      automated: 'אוטומטי',
    },
  },
  coverageCapacityChart: {
    title: 'קיבולת כיסוי',
    bars: {
      capacity: 'קיבולת',
    },
  },
  fleetAcceptanceChart: {
    title: 'קבלת צי רכבים',
    bars: {
      acceptance: 'קבלה',
    },
  },
  noShowCancelationChart: {
    title: 'שיעורי אי-הגעה וביטול',
    bars: {
      noShow: 'אי-הגעה',
      cancelation: 'ביטול',
    },
  },
  onTimePerformanceChart: {
    title: 'ביצוע בזמן',
    bars: {
      onTime: 'בזמן',
    },
  },
};

export default performanceDashboard;
